import classnames from 'classnames'
import DeviceDetector from 'device-detector-js'
import React, { useEffect, useState } from 'react'
import { usePageContext } from 'src/contexts/page.context'
import { useSecurityContext } from 'src/contexts/security.context'
import { Security } from 'src/shared/security.dto'
import { capitalise, makeSecurityLink } from 'src/shared/utils'

import * as styles from './signup-buttons.module.scss'

const deviceDetector = new DeviceDetector()

export const SignupButtons: React.FC = () => {
  const { siteUrl } = usePageContext()
  const { security } = useSecurityContext()
  const [utmLink, setUtmLink] = useState('')
  useEffect(() => {
    if (window) {
      const device = deviceDetector.parse(navigator.userAgent)
      setUtmLink(buildFtLandingPage(security, device, siteUrl))
    }
  }, [])

  return (
    <>
      <div className={styles.signupButtons}>
        <a
          href={`${siteUrl}/auth/v2/google/register/?ft-landing_page=${utmLink}`}
          className={classnames(styles.signupButton, styles.signupButtonGoogle)}
          rel="noopener"
        >
          <span className={styles.signupButton__icon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <path
                fill="#FFC107"
                d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
              />
              <path
                fill="#FF3D00"
                d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
              />
              <path
                fill="#4CAF50"
                d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
              />
              <path
                fill="#1976D2"
                d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
              />
            </svg>
          </span>
          <span className={styles.signupButton__label}>
            Unlock
            <span className={styles.signupButton__labelExtended}>
              &nbsp;with Google
            </span>
          </span>
        </a>

        <a
          href={`${siteUrl}/auth/v2/facebook/register/?ft-landing_page=${utmLink}`}
          className={classnames(
            styles.signupButton,
            styles.signupButtonFacebook,
          )}
          rel="noopener"
        >
          <span className={styles.signupButton__icon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
              <path
                fill="#FFF"
                d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
              />
              <path
                fill="#3F51B5"
                d="M34.368,25H31v13h-5V25h-3v-4h3v-2.41c0.002-3.508,1.459-5.59,5.592-5.59H35v4h-2.287C31.104,17,31,17.6,31,18.723V21h4L34.368,25z"
              />
            </svg>
          </span>
          <span className={styles.signupButton__label}>
            Unlock
            <span className={styles.signupButton__labelExtended}>
              &nbsp;with Facebook
            </span>
          </span>
        </a>
      </div>
      <p className="stk-space-out-t-2">
        Or
        <a href={`${siteUrl}/auth/register/`}>&nbsp;unlock with your email</a>
      </p>
    </>
  )
}

function buildFtLandingPage(
  security: Security,
  device: DeviceDetector.DeviceDetectorResult,
  siteUrl: string,
) {
  const securityPath = makeSecurityLink(security)

  const params: { [key: string]: string | undefined } = {
    'ft-landing_page_type': 'auth',
    'ft-referrer': document.referrer,
    'ft-browser': device.client?.name,
    'ft-device': capitalise(device.device?.type || ''),
    'ft-screen_width': `${screen.width}`,
    'ft-screen_height': `${screen.height}`,

    'ft-sessionCount': localStorage.getItem('sessionCount') || '1',
    'ft-pageCount': localStorage.getItem('pageCount') || '1',
  }

  const query = Object.keys(params)
    .map((key) => `${key}=${params[key] || ''}`)
    .join('&')

  const landingPage = `${siteUrl}/auth/login/?redirect=https://app.stockopedia.com/share-prices${securityPath}&${query}`

  const redirect = `https://app.stockopedia.com/share-prices${securityPath}&${query}&ft-landing_page=${landingPage}`

  return encodeURIComponent(
    `${siteUrl}/auth/login/?redirect=${encodeURIComponent(redirect)}`,
  )
}
